import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';

import { FETCH_APPOINTMENT } from 'modules/appointmentInfo/actions/fetchAppointment';
import { FETCH_APPOINTMENT as FETCH_APPOINTMENT_SERVICE } from 'modules/appointmentInfo/services/fetchAppointment';
import requestsStatuses from 'modules/common/constants/requestsStatuses';


export const fetchAppointmentById = (appointmentId, background = false, isUpdate = false) => (dispatch, getState) => {
  const state = getState();
  const { fetchGroupedStatus } = state.appointmentInfo.currentAppointment;
  const currentSelectedAppointmentId = state.queues.common.appointmentInfo.appointmentId;

  if (requestsStatuses.pending === fetchGroupedStatus) {
    return Promise.resolve();
  }

  const apiCallParams = {
    query: FETCH_APPOINTMENT_SERVICE,
    variables: { appointmentId },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { appointment } }) => {
      if (
        (currentSelectedAppointmentId === appointmentId
        && !(state.appointmentInfo.currentAppointment.group && state.appointmentInfo.currentAppointment.status !== appointment.status))
        || isUpdate
      ) {
        const schedules = appointment.schedules.filter(({ status }) => status === 'CREATED');

        dispatch({
          type: FETCH_APPOINTMENT.success,
          payload: {
            appointment: {
              ...appointment,
              schedules,
            },
          },
        });
      }

      return { appointment };
    })
    .catch(() => {
    });
};
